import React from 'react'
import Grid from "@blocks/Grid"
import useCountries from "@hooks/models/useCountries"
import AspectRatio from '@blocks/AspectRatio'
import Image from '@blocks/Input/Image'
import Input from '@blocks/Input'
import Select from '@blocks/Select'

export default function JuryForm({ model: jury }: Modules.Resource.Form<Interfaces.Jury.Includes<"country">>) {
    const { country, options } = useCountries(jury?.country?.id)
    
    return (
        <Grid>
            <Grid columns="2">
                <Grid gap="20px">
                    <AspectRatio width={1} height={1}>
                        <Image id="avatar" name="avatar" src={jury?.avatar_url} />
                    </AspectRatio>
                </Grid>
                <Grid gap="20px">
                    <Input id="first_name" name="first_name" defaultValue={jury?.first_name} label="First name" placeholder="John" required />
                    <Input id="last_name" name="last_name" defaultValue={jury?.last_name} label="Last name" placeholder="Doe" required />
                </Grid>
                <Grid gap="20px">
                    <Input id="email" name="email" type="email" defaultValue={jury?.email} label="Email" placeholder="john@doe.com" required />
                    <Input id="password" name="password" type="password" label="Password" placeholder="********" required={!jury?.id} />
                    <Input id="password_confirmation" name="password_confirmation" type="password" label="Repeat password" placeholder="********" required={!jury?.id} />
                </Grid>
                <Grid gap="20px">
                    <Select id="country_id" name="country_id" value={country} label="Country" options={options} placeholder="Select" required />
                    <Input id="title" name="title" label="Title" defaultValue={jury?.title} placeholder="EFIAP" />
                </Grid>
            </Grid>
        </Grid>
    )
}